import { Component, EventEmitter, Output } from '@angular/core';

// Right panel header (specs/ai-agent-home-redesign US-10).
@Component({
  selector: 'app-agent-pulse-header',
  templateUrl: './agent-pulse-header.component.html',
  styleUrls: ['./agent-pulse-header.component.scss'],
})
export class AgentPulseHeaderComponent {
  @Output() close = new EventEmitter<void>();
}
